import { render, staticRenderFns } from "./FileRow.vue?vue&type=template&id=26606d1c&"
import script from "./FileRow.vue?vue&type=script&lang=js&"
export * from "./FileRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26606d1c')) {
      api.createRecord('26606d1c', component.options)
    } else {
      api.reload('26606d1c', component.options)
    }
    module.hot.accept("./FileRow.vue?vue&type=template&id=26606d1c&", function () {
      api.rerender('26606d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/approvalFiles/FileRow.vue"
export default component.exports